// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.dynamic.form.FieldOptionResponse */
/* istanbul ignore next */
@GandalfModel
export class FieldOptionResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	abbreviation!: string | null;

	@GandalfProperty({ designType: Boolean })
	active!: boolean | null;

	@GandalfProperty({ designType: Number })
	displayOrder!: number | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: Boolean })
	isAbnormal!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	isDefaultNormal!: boolean | null;

	@GandalfProperty({ designType: String })
	value!: string | null;

}
